export default {
    config: {
        // Optional parameters
        loop: true,
        preloadImages: false,
        lazyLoading: true,
        // Navigation/Pagination
        pagination: '.swiper__pagination',
        nextButton: '.swiper__button--next',
        prevButton: '.swiper__button--prev',
        // BEM styled CSS
        containerModifierClass : 'swiper__container--',
        wrapperClass : 'swiper__wrapper',
        slideClass : 'swiper__slide',
        slideActiveClass : 'slide--active',
        slideDuplicatedActiveClass : 'slide--duplicate-active',
        slideVisibleClass : 'slide--visible',
        slideDuplicateClass : 'slide--duplicate',
        slideNextClass : 'slide--next',
        slideDuplicatedNextClass : 'slide--next',
        slidePrevClass : 'slide--prev',
        slideDuplicatedPrevClass : 'slide--prev',
        bulletClass : 'swiper__bullet',
        bulletActiveClass : 'bullet--active',
        paginationHiddenClass : 'pagination--hidden',
        paginationCurrentClass : 'pagination--current',
        paginationTotalClass : 'pagination__total',
        paginationProgressbarClass : 'pagination__progressbar',
        paginationClickableClass : 'pagination--clickable',
        paginationModifierClass : 'pagination--',
        buttonDisabledClass : 'pagination--disabled',
        lazyLoadingClass : 'has-lazyload',
        lazyStatusLoadingClass : 'is-loading',
        lazyStatusLoadedClass : 'has-loaded',
        lazyPreloaderClass : 'swiper__preloader',
        preloaderClass : 'preloader',
        zoomContainerClass : 'swiper__zoom-container',
        notificationClass : 'swiper__notification',
        //init swiper pagination
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/config/slider.js